import {
  Component,
  ContentChild,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'pr-input-select-template',
    templateUrl: './pr-input-select-template.component.html',
    styleUrls: ['./pr-input-select-template.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputSelectTemplateComponent,
        },
    ],
    standalone: false
})
export class PrInputSelectTemplateComponent<
    T extends { label: string; value: any },
  >
  implements OnInit, ControlValueAccessor
{
  @Input() formControlName: string;
  @Input()
  options: any[];
  @Input() classActive = 'active';
  @Input() isGrid = false;

  @ContentChild('optionTemplate', { static: true })
  optionTemplateRef: TemplateRef<any>;
  picked: T;
  value: any;
  onChange: any = value => {};
  onTouch: any = () => {};

  constructor(private controlContainer: ControlContainer) {}
  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }
  ngOnInit() {
    if (this.control) this.value = this.control.value || '';
  }
  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  selectOption(option: T) {
    this.picked = option.value;
    this.value = option.value;
    this.onChange(option.value);
  }
}
